import {NavDropdown} from "react-bootstrap";
import {ThemeMode, useTheme} from "./ThemeContext";

const modes: { mode: ThemeMode, label: string, icon: string }[] = [
    { mode: 'light', label: 'Light', icon: 'bi-sun-fill' },
    { mode: 'dark', label: 'Dark', icon: 'bi-moon-stars-fill' },
    { mode: 'auto', label: 'Auto', icon: 'bi-circle-half' }
];

export function ThemeToggle() {
    const {mode, setMode} = useTheme();
    const currentIcon = modes.find(x => x.mode === mode)?.icon;
    return (
        <NavDropdown align="end" id="theme-toggle" title={<><i className={`bi ${currentIcon}`}></i><span className="visually-hidden">Colour mode</span></>}>
            {modes.map(x => (
                <NavDropdown.Item key={x.mode} active={x.mode === mode} onClick={() => setMode(x.mode)}>
                    <i className={`bi ${x.icon} me-2`}></i>{x.label}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
}
